import {ComputedHeldPosition} from '../../../../components/dex/dex-streaming/types/computed/computed-held-position';
import {
    createColumnsDict,
    Table,
    TABLE_COLUMN_SIZING_FN,
    TableColumn,
    TableColumnConfig,
    TableColumnsDefMap,
    TableColumnsSizingStep
} from '../../../../components/tables/table';

export interface DexDisplayTrancheComposItem {
    raw: ComputedHeldPosition;
    percent: number | undefined;
    symbol: string;
    tick: boolean | undefined;

    // TODO
    // yield: ValueWithDp;
}

export type DexTrancheComposTable = Table<DexTrancheComposTableColumnKey, DexDisplayTrancheComposItem>;

export enum DexTrancheComposTableColumnKey {
    PERCENT             = 'PERCENT',
    SYMBOL              = 'SYMBOL',
    TICK                = 'TICK',
    BALANCE             = 'BALANCE',
    ENTRY_VALUE_USD     = 'ENTRY_VALUE_USD',
    RATE_USD            = 'RATE_USD',
    PORTFOLIO_VALUE_USD = 'PORTFOLIO_VALUE_USD',
    YIELD_PERCENT       = 'YIELD_PERCENT',
    SNAPSHOT            = 'SNAPSHOT'
}

export interface DexTrancheComposTableColumn extends TableColumn {
    key: DexTrancheComposTableColumnKey;
}

export interface DexTrancheComposTableColumnConfig extends TableColumnConfig {
    key: DexTrancheComposTableColumnKey;
}

export enum DexTrancheComposTableColumnSizeGroup {
    PERCENT,
    SYMBOL,
    TICK,
    BALANCE,
    ENTRY_VALUE_USD,
    RATE_USD,
    PORTFOLIO_VALUE_USD,
    YIELD_PERCENT,
    SNAPSHOT
}

export const DEX_TRANCHE_COMPOS_TABLE_COLUMN_SIZE_GROUPS = [
    DexTrancheComposTableColumnSizeGroup.PERCENT,
    DexTrancheComposTableColumnSizeGroup.SYMBOL,
    DexTrancheComposTableColumnSizeGroup.TICK,
    DexTrancheComposTableColumnSizeGroup.BALANCE,
    DexTrancheComposTableColumnSizeGroup.ENTRY_VALUE_USD,
    DexTrancheComposTableColumnSizeGroup.RATE_USD,
    DexTrancheComposTableColumnSizeGroup.PORTFOLIO_VALUE_USD,
    DexTrancheComposTableColumnSizeGroup.YIELD_PERCENT,
    DexTrancheComposTableColumnSizeGroup.SNAPSHOT
];

export const DEX_TRANCHE_COMPOS_TABLE_COLUMNS_DEF: DexTrancheComposTableColumn[] = [
    {
        label:       '%',
        key:         DexTrancheComposTableColumnKey.PERCENT,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.PERCENT
    },
    {
        label:       'Symbol',
        key:         DexTrancheComposTableColumnKey.SYMBOL,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.SYMBOL
    },
    {
        label:       '+',
        key:         DexTrancheComposTableColumnKey.TICK,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.TICK
    },
    {
        label:       'Balance',
        key:         DexTrancheComposTableColumnKey.BALANCE,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.BALANCE
    },
    {
        label:       'Entry Value USD',
        key:         DexTrancheComposTableColumnKey.ENTRY_VALUE_USD,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.ENTRY_VALUE_USD
    },
    {
        label:       'Rate USD',
        key:         DexTrancheComposTableColumnKey.RATE_USD,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.RATE_USD
    },
    {
        label:       'Portfolio Value USD',
        key:         DexTrancheComposTableColumnKey.PORTFOLIO_VALUE_USD,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.PORTFOLIO_VALUE_USD
    },
    {
        label:       'Yield',
        key:         DexTrancheComposTableColumnKey.YIELD_PERCENT,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.YIELD_PERCENT
    },
    {
        label:       'Snapshot',
        key:         DexTrancheComposTableColumnKey.SNAPSHOT,
        width:       '10%',
        sizeGroupId: DexTrancheComposTableColumnSizeGroup.SNAPSHOT
    }
];

export const DEX_TRANCHE_COMPOS_TABLE_COLUMNS_DICT: TableColumnsDefMap<DexTrancheComposTableColumnKey, DexTrancheComposTableColumn> =
                 createColumnsDict(DEX_TRANCHE_COMPOS_TABLE_COLUMNS_DEF);

export const DEX_TRANCHE_COMPOS_TABLE_COLUMNS_SIZING:
                 Array<TableColumnsSizingStep<DexTrancheComposTableColumnSizeGroup>> =
                 [
                     ...DEX_TRANCHE_COMPOS_TABLE_COLUMN_SIZE_GROUPS
                         .map<TableColumnsSizingStep<DexTrancheComposTableColumnSizeGroup>>(sizeGroupId => ({
                             sizeGroupId,
                             getGroupSize: TABLE_COLUMN_SIZING_FN.fixedWidth(50)
                         })),
                     ...DEX_TRANCHE_COMPOS_TABLE_COLUMN_SIZE_GROUPS
                         .filter(sizeGroupId =>
                             sizeGroupId !== DexTrancheComposTableColumnSizeGroup.SYMBOL
                         )
                         .map<TableColumnsSizingStep<DexTrancheComposTableColumnSizeGroup>>(sizeGroupId => ({
                             sizeGroupId,
                             getGroupSize: TABLE_COLUMN_SIZING_FN.fitContent(8)
                         })),
                     {
                         sizeGroupId:  DexTrancheComposTableColumnSizeGroup.SYMBOL,
                         getGroupSize: TABLE_COLUMN_SIZING_FN.stretch()
                     }
                 ];
